import { get, keyBy, forEach } from 'lodash';

function validateOxygenChecks(caseConf, nodeInfo) {
  const oxygens = (caseConf._oxygens || []).filter(o => get(o, 'options.enabled'));
  const oxygensById = keyBy(oxygens, 'id');
  const errors = [];
  const warnings = [];
  nodeInfo.checkNodes.forEach((checkNode) => {
    forEach(checkNode.data, (check, checkKey) => {
      if (check.id !== 'OXYGEN') return;

      if (!oxygens.length) {
        warnings.push({
          message: 'Oxygen is not enabled',
          category: 'caseLogic',
          field: 'caseLogicDescription',
          id: checkNode.id,
          metadata: {
            nodeId: checkNode.id,
            scope: 'control',
          },
        });
      }

      (check.oxygens || []).forEach((oxygenRoute) => {
        const oxygen = oxygensById[oxygenRoute];

        if (!oxygen || !oxygen.options.enabled) {
          const label = get(oxygen, 'name.en', oxygenRoute);
          warnings.push({
            message: `${label} is used in case logic but is not enabled`,
            category: 'oxygen',
            field: '_oxygens',
            id: oxygenRoute,
            metadata: {
              nodeId: checkNode.id,
              oxygenKey: check.id,
              scope: 'control',
            },
          });
          warnings.push({
            message: `${label} is not enabled`,
            category: 'caseLogic',
            field: 'caseLogicDescription',
            id: checkNode.id,
            metadata: {
              nodeId: checkNode.id,
              checkKey,
              scope: 'control',
            },
          });
        }
      });
    });
  });
  return {
    errors,
    warnings,
  };
}

export default validateOxygenChecks;
